export interface IMediaAltContext {
  title?: string;
  description?: string;
  thought?: string;
  question?: string;
  user?: {
    username?: string;
    summary?: {
      userName?: string;
    };
  };
  group?: {
    name?: string;
  };
  repostedBy?: {
    username?: string;
    summary?: {
      userName?: string;
    };
  };
  repostGroup?: {
    name?: string;
  };
}

export function stripHtml(str?: string): string {
  if (!str) return '';
  return str
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/&quot;/gi, '"')
    .replace(/&#39;/gi, "'")
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/<[^>]*>/g, '')
    .replace(/\s+/g, ' ')
    .trim();
}

export function getMediaAltText(media?: any, postContext?: IMediaAltContext): string {
  // 1. Direct explicit ALT text from backend or media object
  if (media?.altText && typeof media.altText === 'string' && media.altText.trim()) {
    return media.altText.trim();
  }
  if (media?.alt && typeof media.alt === 'string' && media.alt.trim() && !media.alt.startsWith('media-')) {
    return media.alt.trim();
  }
  if (media?.description && typeof media.description === 'string' && media.description.trim()) {
    return media.description.trim();
  }

  // 2. Post Title
  const cleanTitle = stripHtml(postContext?.title);
  if (cleanTitle) {
    return cleanTitle.length > 90 ? `${cleanTitle.slice(0, 87)}...` : cleanTitle;
  }

  // 3. Post Content / Thought / Question
  const rawText = postContext?.thought || postContext?.question || postContext?.description;
  const cleanText = stripHtml(rawText);
  if (cleanText) {
    return cleanText.length > 90 ? `${cleanText.slice(0, 87)}...` : cleanText;
  }

  // 4. Author & Group context
  const authorName =
    postContext?.user?.summary?.userName ||
    postContext?.user?.username ||
    postContext?.repostedBy?.summary?.userName ||
    postContext?.repostedBy?.username;
  const groupName = postContext?.group?.name || postContext?.repostGroup?.name;

  if (authorName && groupName) {
    return `Image posted by ${authorName} in ${groupName}`;
  }
  if (authorName) {
    return `Image posted by ${authorName}`;
  }
  if (groupName) {
    return `Image in ${groupName}`;
  }

  // 5. Cleaned File Name fallback (if meaningful)
  const fileName = media?.fileName;
  if (fileName && typeof fileName === 'string') {
    const baseName = fileName.split('.').slice(0, -1).join('.') || fileName;
    // Check if filename is not just a raw UUID/hash
    const cleaned = baseName.replace(/[-_]+/g, ' ').trim();
    if (cleaned && !/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}/i.test(baseName)) {
      return cleaned;
    }
  }

  // 6. Ultimate safe, non-generic fallback
  return 'User uploaded post image';
}
